import React from 'react';

import {useTranslation} from '@aboutyou/i18n';
import {Heading16, Heading20, UnstyledLink} from '@aboutyou/ui-components';
import styled from 'styled-components';
import {ArrowButton} from '../shared/ArrowButton';
import {HelpCenterNavigationContainer} from '../shared/HelpCenterNavigationContainer';
import {GetSelfServiceFlowSectionResponse} from '../types';

interface HighlightedArticlesViewProps {
  highlightedArticles: GetSelfServiceFlowSectionResponse['highlightedArticles'];
  smallTitle?: boolean;
}

export const HighlightedArticlesView = ({
  highlightedArticles,
  smallTitle = false,
}: HighlightedArticlesViewProps) => {
  const {t} = useTranslation();

  if (highlightedArticles.length === 0) {
    return null;
  }
  const TitleComponent = smallTitle ? Heading16 : Heading20;

  return (
    <HelpCenterNavigationContainer light>
      <Margin>
        <TitleComponent>{t('Other FAQs')}</TitleComponent>
      </Margin>
      <LinksContainer>
        {highlightedArticles.map(link => (
          <UnstyledLink key={link.linkTarget.url} to={link.linkTarget.url}>
            <ArrowButton>{link.label}</ArrowButton>
          </UnstyledLink>
        ))}
      </LinksContainer>
    </HelpCenterNavigationContainer>
  );
};

const LinksContainer = styled.div`
  max-width: 430px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Margin = styled.div`
  margin-bottom: 40px;
`;
